import { Component, OnInit } from '@angular/core';
import { GroupWord } from '../interfaces/GroupWord.interface';
import { GroupWordService } from '../service/group-word.service';

@Component({
  selector: 'app-group-word-list',
  templateUrl: './group-word-list.component.html',
  styleUrls: ['./group-word-list.component.css'],
})
export class GroupWordListComponent implements OnInit {
  groupWords: GroupWord[];

  constructor(private groupWordService: GroupWordService) {
    this.get();
  }

  ngOnInit(): void {}

  get() {
    this.groupWordService.get().then((res) => {
      this.groupWords = res;
    });
  }
}
